
import { EventType } from "@/types/event";
import { formatDistanceToNow, format } from "date-fns";
import { CalendarClock, MapPin } from "lucide-react";
import { Badge } from "@/components/ui/badge";

interface EventCardProps {
  event: EventType;
  onClick?: () => void;
}

const EventCard = ({ event, onClick }: EventCardProps) => {
  // Format the event date and time
  const formatEventDateTime = () => {
    const start = new Date(event.startDate);
    const end = new Date(event.endDate);
    
    const sameDay = start.toDateString() === end.toDateString();
    const startDate = format(start, "EEE, MMM d");
    const endDate = format(end, "EEE, MMM d");
    
    const startTime = format(start, "h:mm a");
    const endTime = format(end, "h:mm a");
    
    if (sameDay) {
      return `${startDate} · ${startTime} - ${endTime}`;
    } else {
      return `${startDate} - ${endDate}`;
    }
  };

  const timeUntil = formatDistanceToNow(new Date(event.startDate), { addSuffix: true });
  
  return (
    <div 
      className="p-4 bg-white border rounded-lg hover:bg-gray-50 cursor-pointer transition-colors"
      onClick={onClick}
    >
      <div className="flex items-start justify-between">
        <div className="space-y-1">
          <h3 className="font-medium text-black">{event.title}</h3>
          <div className="flex items-center text-sm text-gray-500">
            <CalendarClock className="w-4 h-4 mr-1" />
            <span>{formatEventDateTime()}</span>
          </div>
          
          {event.location && (
            <div className="flex items-center text-sm text-gray-500">
              <MapPin className="w-4 h-4 mr-1" />
              <span>{event.location}</span>
            </div>
          )}
          
          <div className="flex items-center space-x-2 pt-1">
            {event.group && (
              <Badge className={event.color || "bg-blue-100 text-blue-800"}>
                <span className="text-black">{event.group}</span>
              </Badge>
            )}
            <span className="text-xs text-gray-400">{timeUntil}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventCard;
